import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ChaseProfileTransactionDetails } from '@externalusermodel/ChaseProfileTransactionDetails';
import { Router, ActivatedRoute } from '@angular/router';
import { ExternalUserService } from '@externaluserservice/external-user.service';

@Component({
    selector: 'app-order-status-profile',
    templateUrl: './order-status-profile.component.html',
    styleUrls: ['./order-status-profile.component.css'],
    providers: [ExternalUserService],
    standalone: false
})
export class OrderStatusProfileComponent implements OnInit {

  private sub: any;

  status: string;
  chaseOrderId: string;

  transactionStatus: ChaseProfileTransactionDetails = new ChaseProfileTransactionDetails();

  constructor(private location: Location, private router: Router, private route: ActivatedRoute, private externalUserService: ExternalUserService) { }

  ngOnInit() {
    // debugger;

    this.location.subscribe(change => {
      if(!change.url.includes("uId"))
        this.router.navigate(['Invoice']);
    });

    this.sub = this.route.params.subscribe(params => {
      this.chaseOrderId = params['chaseOrderId'];
      this.status = params['status'];

      this.externalUserService.getTransactionDetailsFromChaseOrderId(this.chaseOrderId).subscribe(
        (p: ChaseProfileTransactionDetails) => {
          // debugger;
          this.transactionStatus = p;
          //console.log(this.transactionStatus);
        });

    });
  }

  home() {
    this.router.navigate(['Invoice', 'order']);
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>MediaPay - Order Payment</title>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );

    let btn = popupWin.document.getElementById('goToHome');
    btn.parentNode.removeChild(btn);
    popupWin.document.close();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
